import { rotate } from "csx";
import { keyframes, style } from "typestyle";

type SpinnerSizeStyling = string;
type SpinnerThemeStyling = string;

export type SpinnerSizes = {
  small: SpinnerSizeStyling;
  normal: SpinnerSizeStyling;
  large: SpinnerSizeStyling;
};

export type SpinnerThemes = {
  black: SpinnerThemeStyling;
  white: SpinnerThemeStyling;
};

export const sizes: SpinnerSizes = {
  small: style({ width: 16, height: 16, borderWidth: 2 }),
  normal: style({ width: 26, height: 26, borderWidth: 3 }),
  large: style({ width: 36, height: 36, borderWidth: 4 }),
};

export const themes: SpinnerThemes = {
  black: style({
    borderColor: "rgba(0, 0, 0, 0.4)",
    borderTopColor: "rgba(0, 0, 0, 0.15)",
  }),
  white: style({
    borderColor: "rgba(255, 255, 255, 0.85)",
    borderTopColor: "rgba(255, 255, 255, 0.25)",
  }),
};

const spin = keyframes({
  "0%": { transform: rotate("0deg") },
  "100%": { transform: rotate("360deg") },
});

export const spinner = style({
  borderRadius: "50%",
  borderStyle: "solid",
  animationName: spin,
  animationDuration: "0.5s",
  animationIterationCount: "infinite",
  animationTimingFunction: "linear",
});
